import { QueryParams, useNativeDownload } from '@hooks/download/useNativeDownload';
import { CONFIG_URL } from '@services/config/config.api';
import { useCallback } from 'react';

import { SubCameraLiteConfiguration } from '@/types/sensor/sensors';

interface VideoDownloadParams {
  from: Date;
  to: Date;
  cameras: SubCameraLiteConfiguration[];
}
export function useDownloadVideo() {
  const downloadUrl = `${CONFIG_URL}/videos/archives/download`;

  const { startDownload: start, isLoading, isError } = useNativeDownload();

  const startDownloadVideos: (params: VideoDownloadParams) => Promise<void> = useCallback(
    ({ from, to, cameras }) => {
      const queryParams: QueryParams = {
        from: from.getTime(),
        to: to.getTime(),
        cameras: encodeURIComponent(JSON.stringify(cameras)),
      };
      return start(downloadUrl, queryParams, `video-archive-${from.toISOString()}-${to.toISOString()}.zip`);
    },
    [downloadUrl, start],
  );

  return { startDownload: startDownloadVideos, isLoading, isError };
}
